import styled from "styled-components";
import { Link } from "react-router-dom";

export const TopBar = styled.div`
  width: 100%;
  background: #0b2a4a;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 500;

  .inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0.4rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .areas {
    opacity: 0.9;
  }

  .topcall {
    color: #fff;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;

    strong { color: #ffb84d; }
  }

  @media (max-width: 768px) {
    .areas { display: none; }
    .inner { justify-content: center; }
  }
`;

export const NavigationContainer = styled.nav`
  height: 76px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  background: #fff;
  box-shadow: 0 2px 14px rgba(11, 42, 74, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;

  @media (max-width: 768px) {
    padding: 0 1rem;
    height: 66px;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0.5rem 0;

  .logo {
    height: 100%;
    width: auto;
    max-height: 100%;
    object-fit: contain;
    transition: transform 0.3s ease;

    &:hover { transform: scale(1.04); }
  }
`;

export const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  @media (max-width: 900px) {
    position: absolute;
    top: 66px;
    left: 0;
    width: 100%;
    background: #fff;
    flex-direction: column;
    gap: 0;
    padding: 0.5rem 0 1rem;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
    display: ${({ $mobileMenuOpen }) => ($mobileMenuOpen ? "flex" : "none")};
  }
`;

export const NavLink = styled.a`
  padding: 0.6rem 0.9rem;
  font-weight: 600;
  color: #243b53;
  transition: all 0.2s ease;
  border-radius: 8px;
  font-size: 0.92rem;
  cursor: pointer;

  &:hover {
    color: #1565c0;
    background: rgba(21, 101, 192, 0.08);
  }

  @media (max-width: 900px) {
    width: 90%;
    text-align: center;
    padding: 0.9rem;
  }
`;

export const NavActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const CallButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #ef5a24;
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.7rem 1.15rem;
  border-radius: 10px;
  white-space: nowrap;
  box-shadow: 0 6px 16px rgba(239, 90, 36, 0.3);
  transition: transform 0.15s ease, background 0.2s ease;

  &:hover { background: #d94a18; transform: translateY(-1px); }
  &:active { transform: translateY(0); }

  .label { line-height: 1; }
  .label small { display: block; font-size: 0.65rem; font-weight: 600; opacity: 0.9; }

  @media (max-width: 768px) {
    padding: 0.6rem 0.9rem;
    font-size: 0.95rem;
    .label small { display: none; }
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  color: #243b53;

  @media (max-width: 900px) {
    display: inline-flex;
  }
`;

export const MainContentContainer = styled.main`
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
`;
